import React, {Component, cloneElement, Fragment} from 'react'

export default class ToC extends Component {
  render () {
    const langList = (
      <ul>
        <li> <a href="/en-US/">English</a> </li>
        <li> <a href="/es-MX/">Español</a> </li>
      </ul>
    )

    return (
      <Fragment>
        <noscript>
          <p>
            Please choose a language.
          </p>
          {cloneElement(langList)}
        </noscript>

        <div style={{display: 'none'}}>
          {cloneElement(langList)}
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ToC.js